var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2189 9.52728L20.3442 10.677L20.7891 10.9269C21.737 11.4595 21.737 12.8325 20.7891 13.365L14.7525 16.7566C13.3524 17.5432 11.6476 17.5432 10.2475 16.7566L4.21092 13.365C3.26302 12.8325 3.26303 11.4595 4.21093 10.9269L4.65585 10.677L6.66334 9.52728M18.6811 14.6461L20.6129 15.6185C21.6092 16.1201 21.6412 17.5398 20.6685 18.0862L14.7525 21.4101C13.3524 22.1966 11.6476 22.1966 10.2475 21.4101L4.4178 18.1347C3.4284 17.5789 3.48291 16.1278 4.5112 15.6487L6.66334 14.6461M14.7525 11.8112L20.7891 8.41961C21.737 7.88705 21.737 6.51405 20.7891 5.98149L14.7525 2.58993C13.3524 1.80336 11.6476 1.80336 10.2475 2.58993L4.21093 5.98149C3.26303 6.51405 3.26302 7.88705 4.21092 8.41961L10.2475 11.8112C11.6476 12.5977 13.3524 12.5977 14.7525 11.8112Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.5e2dc12f182e9441fe8a61a4f3c33e44.svg";
export { ForwardRef as ReactComponent };